// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\BerthProfile\BerthProfileViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthAmenityType, BerthAmenityTypeData, BerthAmenityTypeOptions } from 'data/models/BerthAmenityType';
import { BerthCapability, BerthCapabilityData, BerthCapabilityOptions } from 'data/models/BerthCapability';
import { BerthProfileResponseRef as _BerthProfileResponseRef, BerthProfileResponseRefData as _BerthProfileResponseRefData, BerthProfileResponseRefOptions as _BerthProfileResponseRefOptions } from 'data/models/BerthProfileResponse';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { Port, PortData, PortOptions } from 'data/models/Port';

// BerthProfileResponseData is the class that BerthProfileResponse serializes to/from
export interface BerthProfileResponseData {
    BerthId : number;
	
    Berth : BerthData | null;
	
    Ref : _BerthProfileResponseRefData;
}

// BerthProfileResponseOptions is the class which may be passed to the BerthProfileResponse constructor to define optional initial data values
export interface BerthProfileResponseOptions {
    BerthId : number;
	
    Berth? : BerthOptions | null;
	
    Ref? : _BerthProfileResponseRefOptions;
}

export class BerthProfileResponse {
    public BerthId : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
	
    public Ref : _BerthProfileResponseRef;

    constructor();
    constructor(data : BerthProfileResponseOptions);
    constructor(data: BerthProfileResponseOptions | null = null) {
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
	    
        this.Berth = S.value<Berth | null>(null);
	    
        this.Ref = data && data.Ref !== undefined ? new _BerthProfileResponseRef(data.Ref) : new _BerthProfileResponseRef();
    }

    static key(obj : BerthProfileResponse) {
        return obj.BerthId();
    }
    
    static dataKey(obj : BerthProfileResponseOptions) {
        return obj.BerthId;
    }

    static update(obj : BerthProfileResponse, data : BerthProfileResponseOptions) {
        S.freeze(() => {
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
	        
	        
            if (data.Ref !== undefined) _BerthProfileResponseRef.update(obj.Ref, data.Ref);
        });
    }
}

// BerthProfileResponseRefData is the class that BerthProfileResponseRef serializes to/from
export interface BerthProfileResponseRefData {
	
    AmenityTypes : BerthAmenityTypeData[] | null;
    Capabilities : BerthCapabilityData[] | null;
    Organizations : OrganizationData[] | null;
    Ports : PortData[] | null;
	
    ActivityRefreshRate : number;
    CanEdit : boolean;
    CanEditPort : boolean;
    CanEditSchedulingAuthority : boolean;
}

// BerthProfileResponseRefOptions is the class which may be passed to the BerthProfileResponseRef constructor to define optional initial data values
export interface BerthProfileResponseRefOptions {
	
    AmenityTypes? : BerthAmenityTypeOptions[] | null;
    Capabilities? : BerthCapabilityOptions[] | null;
    Organizations? : OrganizationOptions[] | null;
    Ports? : PortOptions[] | null;
	
    ActivityRefreshRate? : number;
    CanEdit? : boolean;
    CanEditPort? : boolean;
    CanEditSchedulingAuthority? : boolean;
}

export class BerthProfileResponseRef {
	
    public AmenityTypes : SDataArray<BerthAmenityType>;
    public Capabilities : SDataArray<BerthCapability>;
    public Organizations : SDataArray<Organization>;
    public Ports : SDataArray<Port>;
	
    public ActivityRefreshRate : DataSignal<number>;
    public CanEdit : DataSignal<boolean>;
    public CanEditPort : DataSignal<boolean>;
    public CanEditSchedulingAuthority : DataSignal<boolean>;

    constructor();
    constructor(data : BerthProfileResponseRefOptions);
    constructor(data: BerthProfileResponseRefOptions | null = null) {
	    
        this.AmenityTypes = SArray<BerthAmenityType>([]);
        this.Capabilities = SArray<BerthCapability>([]);
        this.Organizations = SArray<Organization>([]);
        this.Ports = SArray<Port>([]);
	    
        this.ActivityRefreshRate = jsonableObservable(S.value<number>(data && data.ActivityRefreshRate !== undefined ? data.ActivityRefreshRate : 0));
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditPort = jsonableObservable(S.value<boolean>(data && data.CanEditPort !== undefined ? data.CanEditPort : false));
        this.CanEditSchedulingAuthority = jsonableObservable(S.value<boolean>(data && data.CanEditSchedulingAuthority !== undefined ? data.CanEditSchedulingAuthority : false));
    }

    static key(obj : BerthProfileResponseRef) {
        return ;
    }
    
    static dataKey(obj : BerthProfileResponseRefOptions) {
        return ;
    }

    static update(obj : BerthProfileResponseRef, data : BerthProfileResponseRefOptions) {
        S.freeze(() => {
	        
	        
            if (data.ActivityRefreshRate !== undefined) obj.ActivityRefreshRate(data.ActivityRefreshRate);
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
            if (data.CanEditPort !== undefined) obj.CanEditPort(data.CanEditPort);
            if (data.CanEditSchedulingAuthority !== undefined) obj.CanEditSchedulingAuthority(data.CanEditSchedulingAuthority);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthProfileResponse.ts